import axios from "axios"

// Pre-auth endpoints: aucun Sanctum token requis, le lead n'a pas encore de compte.

// Map frontend camelCase state keys → snake_case wire format expected by Laravel.
const camelToSnakeAnswers = (data) => {
    if (!data) return data
    const mapping = {
        selectedModules: "selected_modules",
        brevetBlanc: "brevet_blanc",
        niveauActuel: "niveau_actuel",
        timeHours: "time_hours",
        timePerWeekend: "time_per_weekend",
        besoinsSpeciaux: "besoins_speciaux",
    }
    return Object.fromEntries(
        Object.entries(data).map(([k, v]) => [mapping[k] || k, v])
    )
}

/**
 * Hydrate the brevet funnel from a HubSpot submission GUID (LP redirect).
 *
 * The LP brevet form posts to the existing `subscription_1_to_5` HubSpot form
 * (same form the parent fast-track flow uses — all Ads tracking already wired).
 * After submit, HubSpot redirects to `/brevet/start?submissionGUID=xxx` and the
 * front calls this endpoint with that GUID to get back the funnel_state_id and
 * pre-filled user data.
 */
function initFromHubSpot({}, data) {
    return axios.post(`/api/v1/brevet-funnel/init`, data)
}

function startFunnel({}, data) {
    return axios.post(`/api/v1/brevet-funnel/start`, data)
}

function updateAnswers({ stateId }, data) {
    return axios.put(
        `/api/v1/brevet-funnel/${stateId}/answers`,
        camelToSnakeAnswers(data)
    )
}

function createCheckoutSession({ stateId }, data) {
    return axios.post(
        `/api/v1/brevet-funnel/${stateId}/create-checkout-session`,
        data
    )
}

function getFunnelState({ stateId }) {
    return axios.get(`/api/v1/brevet-funnel/${stateId}`)
}

/**
 * Resume a brevet funnel from an admin-issued magic link.
 *
 * The BO copies `/brevet/resume?user=<base64email>` for a warm lead. The front
 * route reads the `user` param and calls this endpoint behind `auth_or_email`;
 * the backend returns the latest FastTrackState so we can hydrate the Context
 * and navigation.replace to the right step in the funnel.
 */
function resume({}, {}, queryParams) {
    return axios.get(`/api/v1/brevet-funnel/resume`, { params: queryParams })
}

/**
 * Code d'affiliation hors scope V1 — endpoint à venir.
 * Stub conservé pour ne pas casser la chaîne d'appel côté UI (banner referrer).
 */
async function peekReferralCode() {
    return { data: { valid: false } }
}

export const brevetFunnelService = {
    initFromHubSpot,
    startFunnel,
    updateAnswers,
    createCheckoutSession,
    getFunnelState,
    resume,
    peekReferralCode,
}
